import Config from "../../config";

const API_URL = Config.API_URL || 'https://api.dev.halolynx.com/';
const API_RN_URL = Config.API_RN_URL || 'https://apirenewals.dev.halolynx.com/';

const STRIPE_KEY_GB =  process.env.MIX_CHE_155_STRIPE_KEY|| ''
const STRIPE_KEY_IE =  process.env.MIX_CHE_156_STRIPE_KEY || ''
const STRIPE_KEY_BLUE =  process.env.MIX_CHE_156_STRIPE_KEY || ''


const ADDRESS_GB_API = Config.ADDRESS_GB_API || 'https://api.getAddress.io/v2/uk';
const ADDRESS_GB_KEY = Config.ADDRESS_GB_KEY || 'IcbHegyuv0-ulJTX8FUJ7g4456';

const ADDRESS_IE_API = Config.ADDRESS_IE_API || 'https://stagingapi.blueinsurance.ie/geo/search/ie';
const ADDRESS_IE_KEY = Config.ADDRESS_IE_KEY || '';

const GTM_GB = Config.GTM_GB || 'GTM-5W7Q8S9';
const GTM_IE =Config.GTM_IE || 'GTM-W9ZTWBT';


export const S3_BUCKET_LINK = 'https://documents.poweredbylynx.com'

const CMS_GB = Config.CMS_GB || 'https://carhireexcess-co-uk.ppr.halolynx.com/';
const CMS_IE = Config.CMS_IE || 'https://carhireexcess-ie.ppr.halolynx.com/';

const IPID_GB = S3_BUCKET_LINK + '/CHE/GB/2063_CHE_UK_IPID_A4.pdf';
const IPID_IE = S3_BUCKET_LINK + '/CHE/IE/2063-CHE-IE-IPID-A4-20230303.pdf';

const PW_GB = S3_BUCKET_LINK + '/CHE/GB/2075_CHE_UK_Dual_Policy_A4.pdf';
const PW_IE = S3_BUCKET_LINK + '/CHE/IE/2046_CHE_IE_Dual_Policy_Lloyds_A4.pdf';
const PW_BLUE = "https://www.blueinsurance.ie/common/2043_BLUE_IE_Direct_Car_Hire_Excess_Policy_LLoyds_A4.pdf"


const TOBA_GB = S3_BUCKET_LINK + '/CHE/GB/CM-BIL_TOB_UK_12.12.2023.pdf';
const TOBA_IE = S3_BUCKET_LINK + '/CHE/IE/CM-BIL_TOB_IRL_31.03.2023.pdf';
const TOBA_BLUE="https://www.blueinsurance.ie/toba/IE/";

const SRA_IE = S3_BUCKET_LINK + '/CHE/IE/SRA_LATEST.pdf';
const SRA_BLUE = S3_BUCKET_LINK + '/CHE/BLUE/SRA_LATEST.pdf';


const PROXY = '';


export default {
    // agency_code: 155,
    // region: 'GB',
    agency_code: 158,
    region: 'IE',
    additionalDriverLimit: 5,

    API_URL,
    API_RN_URL,
    PRODUCTS_URL: API_URL+'product/v3.1/',

    STRIPE_KEY_GB,
    STRIPE_KEY_IE,
    STRIPE_KEY_BLUE,

    ADDRESS_GB_API,
    ADDRESS_GB_KEY,
    ADDRESS_IE_API,
    ADDRESS_IE_KEY,

    IPID_GB, IPID_IE,
    PW_GB, PW_IE,
    PW_BLUE,
    TOBA_GB, TOBA_IE,TOBA_BLUE,
    SRA_IE, SRA_BLUE,

    CMS_GB,CMS_IE,

    GTM_GB, GTM_IE,

    PROXY,
};

export const regionConfigs = [
    {
        agency_code: 155,
        region: 'GB',
        domain_check: '.co.uk',
        path_check: '/uk',
        dev_check: '-co-uk',
        address_api: '',
    },
    {
        agency_code: 156,
        region: 'IE',
        domain_check: '.ie',
        path_check: '/ie',
        dev_check: '-ie',
        address_api: '',
    },
    {
        agency_code: 158,
        region: 'IE',
        domain_check: 'blueinsurance.ie',
        path_check: '/ie',
        dev_check: '-ie',
        address_api: '',
    },
    {
        agency_code: 157,
        region: 'GB',
        domain_check: '.co.uk',
        path_check: '/uk',
        dev_check: '-co-uk',
        address_api: '',
    },
];
